var toArray = require('../../toArray'); // .files fallback, should be implemented in any browser

module.exports = function fallbackApi(dataTransfer) {
  var files = toArray(dataTransfer.files);
  return Promise.resolve(files);
};